
class SignalHistoryFilterFormModel {
  constructor(signalHistoryFilterForm?: SignalHistoryFilterFormModel) {
    this.occurrenceBookSignalHistoryFilterType = signalHistoryFilterForm ? signalHistoryFilterForm.occurrenceBookSignalHistoryFilterType == undefined ? 1 : signalHistoryFilterForm.occurrenceBookSignalHistoryFilterType : 1;
    this.excludeAlarmTypes = signalHistoryFilterForm ? signalHistoryFilterForm.excludeAlarmTypes == undefined ? [] : signalHistoryFilterForm.excludeAlarmTypes : [];
    this.fromDate = signalHistoryFilterForm ? signalHistoryFilterForm.fromDate == undefined ? null : signalHistoryFilterForm.fromDate : null;
    this.toDate = signalHistoryFilterForm ? signalHistoryFilterForm.toDate == undefined ? null : signalHistoryFilterForm.toDate : null;
  }

  occurrenceBookSignalHistoryFilterType?: number;
  excludeAlarmTypes?: string[];
  fromDate?: string;
  toDate?: string;
}


export { SignalHistoryFilterFormModel }

